import { Outlet, useOutletContext, useParams } from 'react-router-dom'

import { useAppSelector } from '@/main/app/hooks/storeHooks'

import type { List } from '@/main/features/List/listSlice'

import { useList } from '@/main/features/List/hooks/useList'

export function SidebarCartLayout() {
  const { id } = useParams()

  const list = useList(id)
  const isReady = useAppSelector((state) => state.app.isReady)

  return <Outlet context={{ list, isReady }} />
}

export function useCart() {
  return useOutletContext<{ list?: List; isReady: boolean }>()
}
